import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmt } from "../lib/api";

export const gradeLabel = (m) => (m.grade ? `${(m.spesifikasi || "").split("/")[0].trim()} ${m.grade}` : "");
export const GradeChip = ({ label, testid }) => (label ? <span className="grade-chip" data-testid={testid}>{label}</span> : <span data-testid={testid} />);

export default function MovementPicker({ onPick, testid, barcodeId = "" }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const t = setTimeout(() => api.get("/revisi/outbound-candidates", { params: { q, barcode_id: barcodeId } }).then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e))), 300);
    return () => clearTimeout(t);
  }, [q, barcodeId]);
  return (
    <div data-testid={testid}>
      <label>Cari transaksi APPROVE (ID Pemindahan, Barcode, Material, Vendor, Proyek, SPK)</label>
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="MOV-... / MAT-... / proyek" data-testid={`${testid}-input`} />
      <div className="table-wrap"><table className="data-table"><thead><tr><th>ID Pemindahan</th><th>Tanggal</th><th>Barcode / Material</th><th>Grade</th><th>Area</th><th>Qty Keluar</th><th>Vendor / Proyek</th><th></th></tr></thead><tbody>
        {rows.length === 0 && <tr><td colSpan="8" className="empty">Tidak ada transaksi APPROVE / 暂无已批准交易</td></tr>}
        {rows.map((m) => <tr key={m.movement_id}><td>{m.movement_id}</td><td>{m.tanggal}</td><td><b>{m.material_code}</b><br /><small>{m.barcode_id}</small></td><td><GradeChip label={gradeLabel(m)} /></td><td>{m.area}</td><td><b>{fmt(m.qty)}</b> {m.satuan}</td><td>{m.vendor || "-"} / {m.proyek}</td>
          <td><button className="btn-mini" onClick={() => onPick(m)} data-testid={`${testid}-pick-${m.movement_id}`}>Pilih</button></td></tr>)}
      </tbody></table></div>
    </div>
  );
}
